module.exports = __webpack_public_path__ + "img/product4.c0aaeaef.jpg";